
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 25 25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 4","cx":"12.5","cy":"12.5","r":"12.5","fill":"#35bdd1"}}),_c('path',{attrs:{"data-name":"Path 1440","d":"M17.65 6.972h-6.027a.377.377 0 0 0 0 .753h5.118l-9.3 9.258a.377.377 0 0 0 .533.533l9.3-9.258v5.118a.377.377 0 1 0 .753 0V7.349a.377.377 0 0 0-.377-.377z","fill":"#fff","stroke":"#fff"}})])
          )
        }
      }
    